import { useState } from 'react';
import { SessionTimeoutConfirmationDialog } from './dialog';
import { Session } from '../../api/framework/session';

interface SessionTimeoutProps {
  onCancelScheduling: () => void;
}

const SessionTimeout: React.FC<SessionTimeoutProps> = (
  props: SessionTimeoutProps
) => {
  const [showSessionTimeoutDialog, setShowSessionTimeoutDialog] =
    useState<boolean>(false);

  Session.Instance.onSessionTimeout = setShowSessionTimeoutDialog;

  const onTimeoutContinueScheduling = () => {
    setShowSessionTimeoutDialog(false);
  };

  const onTimeoutCancel = () => {
    setShowSessionTimeoutDialog(false);
    props.onCancelScheduling();
  };

  return (
    <SessionTimeoutConfirmationDialog
      isOpen={showSessionTimeoutDialog}
      onCancel={onTimeoutCancel}
      onContinueScheduling={onTimeoutContinueScheduling}
    />
  );
};

export default SessionTimeout;
